<div class="container-fluid">
    <app-report reportId="predictiveDashboard" screen="DASHBOARDPREDICTIVE"></app-report>
  </div>